'use strict';

(function () {
  var video = document.querySelector('.video');

  if (!video) {
    return;
  }

  var videoPlay = document.querySelectorAll('.video__play');
  var classes = {
    play: 'video-is-playing'
  };

  videoPlay.forEach(function (el, i) {
    el.addEventListener('click', function () {
      var activeVideo = document.querySelectorAll('.' + classes.play + ' video');
      var _this = el.parentNode.parentNode.querySelector('video');

      // reset any videos playing
      activeVideo.forEach(function (el, i) {
        el.pause();
        el.currentTime = 0;
        el.parentNode.classList.remove(classes.play);
      });

      // play video
      el.parentNode.parentNode.classList.add(classes.play);
      _this.play();

      // reset video on end
      _this.addEventListener('ended', function (e) {
        _this.pause();
        _this.currentTime = 0;
        _this.parentNode.classList.remove(classes.play);
      });
    });
  });
})();